import React from 'react';

export function joinComponents(...components: readonly (React.ReactNode | null | undefined)[]) {
    const result = [];

    for (let i = 0; i < components.length; i++) {
        const node = components[i];

        if (! node) continue;

        result.push(<React.Fragment key={i}>{node}</React.Fragment>);

        if (i !== components.length - 1) result.push(<React.Fragment key={i + '-asc'}>, </React.Fragment>);
    }

    return result.length ? <>{result}</> : undefined;
}
